<template>
  <div>
    <div class="field">
      <div
        class="checkDate mt-field">
        <span>查询日期：</span>
        <span
          id="datePicker"
          class="timePicker"
          @click="open">{{ todayTime }}</span>
      </div>
      <mt-field
        v-model="patientNumber"
        class="mt-field"
        placeholder="请输入患者住院号"
        label="住院号："/>
    </div>
    <div class="select">
      <mt-radio
        :options="people"
        v-model="selectPeople"
        class="mt-radio"
        title="选择就诊对象"/>
      <!-- <div
        class="add-card"
        @click="jumpToAdd">
        <span>+添加就诊人</span>
      </div> -->
      <div style="border: 5px solid #f0f0f0;">
        <div
          class="add-card"
          @click="jumpToAdd">
          <p><img
            src="../../assets/add.png"
            style="width: 16px;height: 16px; margin: 0px 5px">
          <span style="font-size: 16px;color: #2196F3">添加就诊卡</span></p>
          <span><img
            src="@/assets/right.png"
            style="width: 16px;height: 16px"></span>
        </div>
      </div>
      <div class="btn-toolbar">
        <mt-button
          type="primary"
          size="large"
          @click="jumpToFee">查询</mt-button>
      </div>
      <div class="message">
        按照医院管理规定要求，您办完出院手续后，将无法查询到您的费用清单
      </div>
    </div>
  </div>
</template>

<script>
import weui from 'weui.js';
import 'weui/src/style/base/reset.less';
import 'weui/src/style/widget/weui-animate/weui-animate.less';
import 'weui/src/style/widget/weui-picker/weui-picker.less';
import format from 'date-fns/format';
import locale from 'date-fns/locale/zh_cn';
import { Toast } from 'mint-ui';
import Cookies from 'js-cookie';

export default {
  name: 'SingleDayFee',
  data() {
    return {
      todayTime: format((new Date()), 'YYYY-MM-DD', { locale }), // 初始日期
      label: '',
      date: '',
      people: [], // 单选框就诊人列表
      selectPeople: '',
      personName: '', // 就诊人姓名
      patientId: '', // 就诊卡号
      end: Number(format(new Date(), 'YYYY-MM-DD', { locale }).split('-')[0]),
      patientNumber: Cookies.get('patientNumber') === undefined ? '' : Cookies.get('patientNumber'), // 住院号
    };
  },
  mounted() {
    this.patients();
  },
  methods: {
    // 添加就诊对象
    jumpToAdd() {
      this.$router.push({ name: 'PatientEdit', query: { hospitalId: this.$route.query.hospitalId } });
    },
    // 就诊人列表
    async patients() {
      const url = '/patient-api/webapi/user/list-medical-card';
      const config = {
        params: {
          access_token: Cookies.get('token'),
          hospital_id: Number(this.$route.query.hospitalId),
        },
        headers: {
          Authorization: `Bearer ${Cookies.get('token')}`,
        },
      };
      const response = await this.$http.get(url, config);
      const arr = response.list;
      for (let i = 0; i < arr.length; i += 1) {
        this.people.push({
          label: `${arr[i].name} ${arr[i].medical_card_id}`,
          value: `${arr[i].name} ${arr[i].medical_card_id}`,
          relation: arr[i].relation,
          phone: arr[i].phone,
          medical_card_id: arr[i].medical_card_id,
        });
      }
    },
    // 查询
    async jumpToFee() {
      if (!/^[0-9]+$/.test(this.patientNumber)) {
        Toast({
          message: '请输入正确住院号！',
        });
        return;
      }
      if (this.selectPeople === '') {
        Toast({
          message: '请选择就诊人！',
        });
        return;
      }
      Cookies.set('patientNumber', this.patientNumber);
      this.people.forEach((item) => {
        if (item.value === this.selectPeople) {
          this.personName = item.value;
          this.patientId = item.medical_card_id;
        }
      });
      const time = format(this.todayTime, 'YYYY-MM-DD', { locale });
      this.$router.push({
        name: 'HospitalizationFee',
        query: {
          date: time,
          patientName: this.personName,
          healthId: this.patientId,
          inpatientNo: this.patientNumber,
        },
      });
    },
    // 打开时间列表
    open() {
      const time = this.todayTime.split('-');
      const year = time[0];
      const month = time[1];
      const day = time[2];
      weui.datePicker({
        start: 1990,
        end: this.end,
        defaultValue: [year, month, day],
        onChange: () => {
        },
        onConfirm: (result) => {
          if (result[2].value < 10 && result[1].value < 10) {
            this.todayTime = result[0].value.toString().concat('-0', result[1].value, '-0', result[2].value);
          } else if (result[2].value < 10) {
            this.todayTime = result[0].value.toString().concat('-', result[1].value, '-0', result[2].value);
          } else if (result[1].value < 10) {
            this.todayTime = result[0].value.toString().concat('-0', result[1].value, '-', result[2].value);
          } else {
            this.todayTime = result[0].value.toString().concat('-', result[1].value, '-', result[2].value);
          }
        },
        id: 'datePicker',
      });
    },
  },
};
</script>

<style scoped>
  .mt-field {
    border-bottom: 1px solid #dee2e6;
  }
  .checkDate {
    width: 100%;
    line-height: 48px;
    background-color: #ffffff;
    text-align: left;
    padding: 0 10px;
  }
  .timePicker {
    border: 1px solid #dee2e6;
    padding: 5px 8px;
    margin-left: 20px;
  }
  .mt-radio {
    border-bottom:1px solid #dee2e6;
  }
  .select {
    background-color: #ffffff;
    margin-top: 20px;
  }
  .add-card {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    /* padding:2px 10px; */
    border-radius: 10px;
    background-color: white;
    /* margin: 10px 10px 10px 10px; */
    height: 40px;
  }
  .add-card span {
    line-height: 40px;
    color: #2196F3;
    /* padding: 0 20px; */
  }
  .btn-toolbar {
    padding: 10px 10px 0 10px;
  }
  .message {
    padding: 10px;
    color: #757575;
  }
</style>



// WEBPACK FOOTER //
// src/views/charge/single-day-fee.vue